// Exact decimal money helpers. Never use JS floating point for tax amounts.
import { Decimal } from "decimal.js";

export const D = Decimal.clone({ precision: 40, rounding: Decimal.ROUND_HALF_UP });
export type Dec = InstanceType<typeof D>;

/** Parse a money string strictly: optional sign, digits, optional 1-2+ decimals. Parentheses mean negative. */
export function money(input: string): Dec {
  const s = input.trim();
  const m = /^(\()?(-)?\$?(\d{1,3}(,\d{3})+|\d+)(\.\d+)?(\))?$/.exec(s);
  if (!m) throw new Error(`Ambiguous or invalid money value: "${input}"`);
  const paren = Boolean(m[1]) || Boolean(m[6]);
  if (Boolean(m[1]) !== Boolean(m[6])) throw new Error(`Unbalanced parentheses: "${input}"`);
  if (paren && m[2]) throw new Error(`Both minus sign and parentheses: "${input}"`);
  const digits = m[3]!.replace(/,/g, "") + (m[5] ?? "");
  const v = new D(digits);
  return paren || m[2] ? v.neg() : v;
}

export const ZERO = new D(0);

/** Round to cents, half up (form-level rounding is applied separately where instructions require). */
export function cents(v: Dec): Dec {
  return v.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}

/** Round to whole dollars, half up, as IRS forms allow when rounding is elected. */
export function dollars(v: Dec): Dec {
  return v.toDecimalPlaces(0, Decimal.ROUND_HALF_UP);
}

export function max0(v: Dec): Dec {
  return v.lessThan(0) ? ZERO : v;
}

export function minD(a: Dec, b: Dec): Dec {
  return a.lessThan(b) ? a : b;
}

export function fmt(v: Dec): string {
  return cents(v).toFixed(2);
}
